import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ExpenseFormPage from "./ExpenseFormPage";
import ExpenseListPage from "./ExpenseListPage";
import { ExpenseProvider } from "../../store/expenseContext";
import { CurrencyProvider } from "../../store/currencyContext";

const ExpenseIndex: React.FC = () => (
    <CurrencyProvider>
        <ExpenseProvider>
            <Routes>
                <Route path="form" element={<ExpenseFormPage />} />
                <Route path="form/:id" element={<ExpenseFormPage />} />
                <Route path="list" element={<ExpenseListPage />} />
                <Route index element={<Navigate to="list" replace />} />
                <Route path="*" element={<Navigate to="list" />} />
            </Routes>
        </ExpenseProvider>
    </CurrencyProvider>
);

export default ExpenseIndex;
